/*
 * @Author: K
 * @Date: 2022-04-08 13:54:54
 * @LastEditors: owen
 * @LastEditTime: 2022-05-07 18:20:07
 * @FilePath: \app-pcweb\src\utils\request.js
 */
import i18n from "@/lobby_common/locale/index";
import store from "@/lobby_common/store";
import {
  getToken,
  setToken,
  getRefreshToken,
  setRefreshToken,
  removeLocalStorage,
  removeToken,
  getLocalStorage,
} from "./auth";
import { debounce } from "./index";
import axios from "axios";
import { messagebox } from "@/lobby_common/utils/resetMessage.js";
import { Encrypt, Decrypt } from "@/lobby_common/utils/secret.js";
import Bus from "@/lobby_common/utils/bus.js";
import { eventPost } from "@/lobby_common/utils/eventFunction";
import {
  divideAccuracy,
  formatLang,
  getDeviceInfo,
  getContainerClientType,
  // getShowGameLimitDialog,
  getAppPromptInfoFun,
} from "@/lobby_common/utils/utils.js";
import { locationJump } from "@/lobby_common/utils/eventFunction.js";
// import sha256 from "js-sha256";
import Vue from "vue";
// import Router from "@/lobby_common/router/index";
const baseConfing = window.BASEAPI;
const apiWhiteList = [
  "/gathering/v1/event", // 数据上报
  "/adsevent/v1/update/eventid", // 三方数据上报
  "/web/v1/application/lunch/game", // 玩游戏
  "/activity/v1/activity/previewActivityAmount", // 获取彩金接口
  "/game/v1/getMetaMatchSale/list", // 体育赛事
  "/activity/v1/activity/red/receive",
]; // 配置接口地址白名单  ，数据打点 不要提示信息接口
// const SignFun = () => {
//   const dateString = new Date();
//   const time = new Date(dateString.toUTCString());
//   const strTime = time.getTime();
//   const seconds = parseInt(strTime / 1000, 10);

//   const sign = strTime + "_" + seconds;
//   const signSha256 = sha256(sign);
//   return sign + "_" + signSha256;
// };

const inviteList = [
  "/v1/user/register",
  "/v1/user/login",
  "/v1/user/thirdLogin",
];

const activityList = ["/v1/activity/redEnvelopeTimingGet"];

const CONFIG_URL = "/v1/resource/getConf";

let isRefreshing = false; // 标记是否正在刷新 token
let requests = []; // 存储待重发请求的数组

// 数据加密接口列表, "*" 全加密
const secretMap = {
  "*": true,
};
// 是否DEBUG, false加密， true不加密
let skmode = false;
// 上报配置接口地址
let lastConfigUrl = "";
// 上报接口报错
window.eventErrorNum = 0;

function logOut() {
  removeToken();
  removeLocalStorage("gameUrl");
  removeLocalStorage("USER_LOGIN_DATA");
  removeLocalStorage("USER_DATA");
  removeLocalStorage("IS_LOGIN");
  store.commit("setUser", "");
  store.commit("setTaken", "");
  store.commit("setIsLogin", false);
  removeLocalStorage("evryLoginEvent");
  removeLocalStorage("closeDownloadTime");
  removeLocalStorage("activityfirstWithdrawal");
  // window.location.href = "/home";
  locationJump("/home");
}

/**
 * @author
 * @description 处理code异常
 * @param {*} code
 * @param {*} msg
 */
// const messageInstance = null;
// const codestatus = 0;
const handleCodeMsg = (code, msg, response) => {
  //   if (code === 401) {
  //     codestatus = 1;
  //   }

  if (code !== 401) {
    // console.log(code, msg, response);
    const tsr = `msgcode.${code}`;
    let msgs = i18n.tc(tsr);
    const msgcode = msgs.split(".");
    if (msgcode[0].includes("msgcode")) {
      if (!["develop", "sit", "uat"].includes(baseConfing.env)) {
        // msgs = msg;
        // 默认code 7
        msgs = i18n.tc(`msgcode.${7}`);
      }
    }

    if (code === 90025) {
      // code = 90025兑换码冷却时间专用code
      const last_time = response.data?.data?.last_time || "";
      msgs = formatLang(msgs, [last_time]);
    }
    if (code === 1120166) {
      // 提现时间段限制
      const arr = response.data.msg?.split("-");
      msgs = formatLang(i18n.tc("Datalang.Every_day"), [arr[0], arr[1]]);
    }
    if (code === 1120214) {
      // 提现体验钱包余额不足
      const msg = response.data.msg;
      msgs = formatLang(i18n.tc(tsr), [msg]);
    }

    // code弹窗提示
    const codeWinList = [
      1120194, 1120195, 1120196, 1120197, 1120199, 1120202, 1120203, 1120204,
      1120205,
    ];
    const appConfig = store.getters.getPacketConfig?.appConfig || {};
    const gift = appConfig.gift || {};
    if (codeWinList.includes(code)) {
      // 带s%替换翻译，isShowVip是否显示升级VIP按钮
      let isShowVip = false;
      if (code === 1120194) {
        // 最低送礼VIP等级
        isShowVip = true;
        msgs = formatLang(msgs, [gift.minSendRank]);
      }
      if (code === 1120195) {
        // 最低收礼VIP等级
        msgs = formatLang(msgs, [gift.minReceiveRank]);
      }
      if (code === 1120197) {
        // 最低送礼金额
        const coinList = store.getters.getPacketConfig?.coinList || [];
        const giftCoinCode = msg || "BLR"; // msg：赠礼币种giftCoinCode
        const coinObj = coinList.find((v) => v.coinCode === giftCoinCode) || {}; // 赠礼币种giftCoinCode信息
        const minAmountMap = gift.minAmountMap || {}; // 赠礼币种giftCoinCode最小金额
        const minAmount = divideAccuracy(
          minAmountMap[giftCoinCode],
          coinObj.accuracy,
          true
        );
        msgs = formatLang(msgs, [" " + coinObj.symbol + " " + minAmount]);
      }
      Bus.$emit("codeTipsShow", { tipsTxt: msgs, isShowVip: isShowVip });
      return false;
    }

    if (code === 1090167) {
      // 判断是否限制玩游戏---->应用限制  vip0  金额300
      getAppPromptInfoFun();
      return false;
    }

    if (code !== 1050053) {
      messagebox({
        message: msgs || "Error",
        type: "error",
        showClose: true,
      });
    }
  }

  if (code === 401) {
    if (store.getters.getOtherLogin) {
      // 异地登录
      return false;
    }
    logOut();
    return false;
  }
};

export const debouncedPacketDomainError = debounce(() => {
  const domain = store.getters?.getPacketDomain || {};
  eventPost("err_log_getPacketDomain", {
    configurl: lastConfigUrl || "",
    ...domain,
  });
}, 1000);

// console.log(baseConfing.baseApi, "baseConfing.baseApi");
const service = axios.create({
  baseURL: baseConfing.baseApi, // url = base url + request url
  timeout: 30000, // request timeout
});
const serviceRefresh = axios.create({
  baseURL: baseConfing.baseApi, // url = base url + request url
  timeout: 30000, // request timeout
});
serviceRefresh.interceptors.request.use(
  (config) => {
    // config.headers["Sign"] = SignFun();
    config.headers["content-type"] = "application/json";
    config.headers["app"] = "web";
    // config.headers["deviceId"] =
    //   window.deviceId || window.sessionStorage.getItem("deviceId");
    config.headers["X-Header-Language"] = store.getters.getLang;
    // config.headers["X-Header-User-Create-Type"] =
    //   getLocalStorage("localUserType") || "";

    const deviceInfo = getDeviceInfo();
    config.headers["X-Header-Device-Id"] = deviceInfo.deviceId;
    config.headers["X-Header-Device-Name"] = deviceInfo.deviceName;
    config.headers["authorization"] = `Bearer ${getRefreshToken()}`;

    // 第一个接口
    if (config?.url === CONFIG_URL) {
      const queryObj = getLocalStorage("localInitQuery") || {};
      const localSkmode = getLocalStorage("skmode");
      skmode = queryObj.skmode || localSkmode || skmode;
    }
    if (skmode === "true" || skmode === true) {
      config.headers["X-STREAKING-MODE"] = "DEBUG";
    }
    // config.headers["X-STREAKING-MODE"] = "DEBUG";

    // 其他接口添加请求头参数
    const whiteList = [CONFIG_URL]; // 包白名单  请求头不需要带包的信息
    if (!whiteList.includes(config?.url)) {
      config.headers["X-Header-Platform"] =
        store.getters.getPacketDomain?.platformSid || "";
      config.headers["X-Header-App"] =
        store.getters.getPacketDomain?.appSid || "";
      config.headers["X-Header-Package"] =
        store.getters.getPacketDomain?.packSid || "";
      if (
        !store.getters.getPacketDomain?.platformSid &&
        !store.getters.getPacketDomain?.appSid &&
        !store.getters.getPacketDomain?.packSid
      ) {
        lastConfigUrl = config?.url;
        debouncedPacketDomainError();
        // return false;
      }
    }

    const containerClientType = getContainerClientType();
    config.headers["X-Header-Client-Type"] = containerClientType.clientType;
    config.headers["X-Header-Container-Type"] =
      containerClientType.containerType;

    // 空数据默认传 {}
    if (!config.data) {
      config.data = {};
    }
    // 加密
    if ((secretMap["*"] || secretMap[config?.url]) && !skmode) {
      if (config.method?.toLowerCase() === "post" && config.data) {
        if (config.url !== "/v1/basic/uploadImage") {
          config.data = { data: Encrypt(config.data) };
        }
      } else if (config.method?.toLowerCase() === "get" && config.params) {
        config.params = { data: Encrypt(config.params) };
      } else {
        config.data = { data: Encrypt(config.data) };
      }
    }

    return config;
  },
  (error) => {
    // console.log(error, "------uses-----"); // for debug
    return Promise.error(error);
  }
);
// 请求拦截
serviceRefresh.interceptors.response.use(
  (response) => {
    const res = response?.data;
    console.log("refreshToken原始响应:", response);
    // 解密
    if ((secretMap["*"] || secretMap[response?.config?.url]) && !skmode) {
      res.data = Decrypt(res.data) || {};
    }

    return res;
  },
  (error) => {
    console.error("refreshToken请求错误:", error);
    return Promise.reject(error);
  }
);

// 刷新token
const refreshToken = () => {
  return serviceRefresh.post("/v1/user/refreshAccessToken");
};

let ipLimited = false;
const CancelToken = axios.CancelToken;
const source = CancelToken.source();

service.interceptors.request.use(
  (config) => {
    if (ipLimited) {
      // ip受限，后面的请求cancel掉
      source.cancel();
    }
    // config.headers["Sign"] = SignFun();
    config.headers["content-type"] = "application/json";
    config.headers["app"] = "web";
    // config.headers["deviceId"] =
    //   window.deviceId || window.sessionStorage.getItem("deviceId");
    config.headers["X-Header-Language"] = store.getters.getLang;
    // config.headers["X-Header-User-Create-Type"] =
    //   getLocalStorage("localUserType") || "";

    const deviceInfo = getDeviceInfo();
    config.headers["X-Header-Device-Id"] = deviceInfo.deviceId;
    config.headers["X-Header-Device-Name"] = deviceInfo.deviceName;

    const tokenWhiteList = [CONFIG_URL]; // token白名单  请求头不需要带token
    if (getToken() && !tokenWhiteList.includes(config?.url)) {
      config.headers["authorization"] = "Bearer " + getToken();
    }

    // 第一个接口
    if (config?.url === CONFIG_URL) {
      const queryObj = getLocalStorage("localInitQuery") || {};
      const localSkmode = getLocalStorage("skmode");
      skmode = queryObj.skmode || localSkmode || skmode;
    }
    if (skmode === "true" || skmode === true) {
      config.headers["X-STREAKING-MODE"] = "DEBUG";
    }

    // 其他接口添加请求头参数
    const whiteList = [CONFIG_URL]; // 包白名单  请求头不需要带包的信息
    if (!whiteList.includes(config?.url)) {
      config.headers["X-Header-Platform"] =
        store.getters.getPacketDomain?.platformSid || "";
      config.headers["X-Header-App"] =
        store.getters.getPacketDomain?.appSid || "";
      config.headers["X-Header-Package"] =
        store.getters.getPacketDomain?.packSid || "";
      if (
        !store.getters.getPacketDomain?.platformSid &&
        !store.getters.getPacketDomain?.appSid &&
        !store.getters.getPacketDomain?.packSid
      ) {
        lastConfigUrl = config?.url;
        debouncedPacketDomainError();
        // return false;
      }
    }

    const containerClientType = getContainerClientType();
    config.headers["X-Header-Client-Type"] = containerClientType.clientType;
    config.headers["X-Header-Container-Type"] =
      containerClientType.containerType;

    // 空数据默认传 {}
    if (!config.data) {
      config.data = {};
    }

    // 加密
    if (
      (secretMap["*"] || secretMap[config?.url]) &&
      !skmode &&
      !config.skipEncrypt
    ) {
      if (config.method?.toLowerCase() === "post" && config.data) {
        if (config.url !== "/v1/basic/uploadImage") {
          config.data = { data: Encrypt(config.data) };
        }
      } else if (config.method?.toLowerCase() === "get" && config.params) {
        config.params = { data: Encrypt(config.params) };
      } else {
        config.data = { data: Encrypt(config.data) };
      }
    }

    return config;
  },
  (error) => {
    // console.log(error, "------uses-----"); // for debug
    return Promise.error(error);
  }
);

// 响应拦截
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    // 解密
    if ((secretMap["*"] || secretMap[response?.config?.url]) && !skmode) {
      res.data = Decrypt(res.data);
    }

    if (res.code === 1050053) {
      // ip限制
      ipLimited = true;
    }
    if (Number(res.code) === 0) {
      return res;
    } else {
      // console.log(response, "response");
      // console.log(Number(res.code) === 40016 || Number(res.code) === 40017, "----------Number--------");
      if (
        Number(res.code) === 40016 ||
        Number(res.code) === 40017 ||
        Number(res.code) === 40046 ||
        Number(res.code) === 40023
      ) {
        // Token 失效
        if (store.getters.taken) {
          // store.dispatch("signOutPs");
        }
        // 账号不存在
        if (Number(res.code) === 40023) {
          removeLocalStorage("PASSWORD_STR");
        }
      }
      if (Number(res.code) === 1020101) {
        // 进入游戏 或者充值触发了风险限制
        if (["/v1/payment/userRecharge"].includes(response?.config?.url)) {
          // 关闭充值
          Bus.$emit("showCharge", { show: false });
          // 充值限制
          Bus.$emit("riskSetTip", { type: 3, enter: "charge" });
        } else {
          // 游戏限制
          Bus.$emit("riskSetTip", { type: 3, enter: "game" });
        }
        return res;
      }
      if (Number(res.code) === 50014) {
        // 领取新人任务时，没填信息的code，不做提示
        return res;
      }
      if (Number(res.code) === 1140045 || Number(res.code) === 1140046) {
        // 签到条件不够时，不报错误，页面进行弹窗提示
        return res;
      }

      if (
        (Number(res.code) === 1020036 ||
          Number(res.code) === 1020037 ||
          Number(res.code) === 1020067) &&
        inviteList.includes(response?.config?.url)
      ) {
        // 邀请码无效,不报错,弹窗
        return res;
      }

      if (
        (Number(res.code) === 1140009 ||
          Number(res.code) === 1140011 ||
          Number(res.code) === 1140012) &&
        activityList.includes(response?.config?.url)
      ) {
        // 红包雨活动未开始或已结束
        return res;
      }

      if (
        Number(res.code) === 40069 ||
        Number(res.code) === 1120169 ||
        Number(res.code) === 1120171 ||
        Number(res.code) === 1020076 ||
        Number(res.code) === 1120136 ||
        Number(res.code) === 1120189 ||
        Number(res.code) === 1120137
      ) {
        // 登录、提现短信验证 提示绑定手机, 取现密码1120136,1120137
        return res;
      }

      // 系统维护
      if (Number(res.code) === 1050052) {
        // console.log(res.code, Vue.prototype.$isPopShow, "-------10010--------");
        const msg = res.msg ? JSON.parse(res.msg) : {};
        Vue.prototype.$isPopShow({
          show: true,
          views: "maintain",
          data: { close: true, text: msg, width: "800px" },
        });
        return res;
      }

      if (apiWhiteList.includes(response?.config?.url)) {
        return res;
      }
      const errorWhiteList1 = ["/payment/v1/web/user/withdraw"];
      if (
        errorWhiteList1.includes(response?.config?.url) &&
        Number(res.code) === 10024
      ) {
        // 被风控用户
        return false;
      }
      const errorWhiteList2 = ["/v1/user/getCaptcha"];
      if (
        errorWhiteList2.includes(response?.config?.url) &&
        (Number(res.code) === 1020029 || Number(res.code) === 1020077)
      ) {
        // 忘记密码不提示
        return res;
      }
      if (Number(res.code) === 1020082 || Number(res.code) === 1020083) {
        // 多次密码错误，需要Google验证码校验
        // 同IP注册次数太多，需要Google验证码校验
        store.commit("setGoogleRobotShow", true);
        // window.grecaptcha.reset(window.widgetId);
        return res;
      }
      if (Number(res.code) === 1020074) {
        // Google验证码错误
        // window.grecaptcha.reset(window.widgetId);
      }

      // 游戏限制
      if (
        Number(res.code) === 1090170 ||
        Number(res.code) === 1090121 ||
        Number(res.code) === 1090177
      ) {
        // Bus.$emit("gameLimit", true);
        // getShowGameLimitDialog();
        return res;
      }

      // 领奖限制-短信验证
      if (Number(res.code) === 1140075) {
        // 1140075
        Bus.$emit("rewardLimiteShow", { type: "type1" });
        return res;
      }
      // 领奖限制-邮箱验证
      if (Number(res.code) === 1140076) {
        Bus.$emit("rewardLimiteShow", { type: "type2" });
        return res;
      }
      // 领奖限制-出款账户绑定
      if (Number(res.code) === 1140077) {
        Bus.$emit("rewardLimiteShow", { type: "type3" });
        return res;
      }
      // 领奖限制-首充
      if (Number(res.code) === 1140078) {
        Bus.$emit("rewardLimiteShow", { type: "type4" });
        return res;
      }
      // 领奖限制-Facebook绑定
      if (Number(res.code) === 1140079) {
        Bus.$emit("rewardLimiteShow", { type: "type5" });
        return res;
      }
      // 领奖限制-Google绑定
      if (Number(res.code) === 1140080) {
        Bus.$emit("rewardLimiteShow", { type: "type6" });
        return res;
      }
      // 领奖限制-不可以使用app
      if (Number(res.code) === 1140081) {
        Bus.$emit("rewardLimiteShow", { type: "type7" });
        return res;
      }
      // 领奖限制-不可以使用web
      if (Number(res.code) === 1140082) {
        Bus.$emit("rewardLimiteShow", { type: "type8" });
        return res;
      }

      debounce(handleCodeMsg(res.code, res.msg, response), 100);
      return res;
    }
  },
  function (error) {
    let { message } = error;
    const { response } = error;
    // const { config } = response;
    console.log("responseerror=>", error);
    // 刷新token
    if (
      response?.status === 401 &&
      !["/v1/user/refreshAccessToken"].includes(response?.config?.url)
    ) {
      const { config } = response;
      if (!isRefreshing) {
        isRefreshing = true;
        return refreshToken()
          .then((res) => {
            console.log("restoken=>", res);
            const { accessToken } = res.data;
            if (!accessToken) {
              return Promise.reject();
            }
            // 更新token
            store.commit("setTaken", {
              accessToken,
            });
            Bus.$emit("reconnectWebSocket");
            config.headers["authorization"] = `Bearer ${accessToken}`;
            config.skipEncrypt = true;
            // token 刷新后将数组的方法重新执行
            requests.forEach((cb) => cb(accessToken));
            // 重新请求完清空
            requests = [];
            return service(config);
          })
          .catch((err) => {
            // Refresh Token 失效
            console.log("Refresh Token 失效", err);
            // store.dispatch("signOutPs");
            logOut();
            return Promise.reject(err);
          })
          .finally(() => {
            isRefreshing = false;
          });
      } else {
        // 返回未执行 resolve 的 Promise
        return new Promise((resolve) => {
          // 用函数形式将 resolve 存入，等待刷新后再执行
          requests.push((token) => {
            config.headers["authorization"] = `Bearer ${token}`;
            config.skipEncrypt = true;
            resolve(service(config));
          });
        });
      }
    }
    // console.log(message, response, error, "-----error----");
    // 白名单内的接口报错不弹出报错内容
    if (
      apiWhiteList.includes(response?.config?.url) ||
      apiWhiteList.includes(error?.config?.url)
    ) {
      return "";
    }
    if (error?.config?.url === "/event") {
      window.eventErrorNum += 1;
      return "";
    }
    if (error.response && error.response.status) {
      let { status } = error.response;
      if (status >= 500 && status < 600) {
        status = 500;
      }
      if (status === 404) {
        return Promise.reject(error);
      }
      debounce(handleCodeMsg(status, message, response), 100);
      return Promise.reject(error);
    } else {
      if (!window.navigator.onLine) {
        messagebox({
          type: "error",
          showClose: true,
          message: message || "Error",
        });

        return;
      }
      if (message.includes("timeout")) {
        message = "Request Timeout Error";
      }

      if (message == "Network Error") {
        return Promise.reject("");
      }
      messagebox({
        type: "error",
        showClose: true,
        message: message || "Error",
      });
      return Promise.reject(error);
    }
  }
);

const request = service;
export default request;
